import { apiRequest } from './api';

export const notificationsApiService = {
  // Bildirimleri getir
  getNotifications: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.is_read !== undefined) {
      queryParams.append('is_read', params.is_read);
    }
    if (params.type) {
      queryParams.append('type', params.type);
    }
    if (params.priority) {
      queryParams.append('priority', params.priority);
    }
    if (params.limit) {
      queryParams.append('limit', params.limit);
    }
    
    const url = `/notifications/notifications/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return await apiRequest(url);
  },

  // Okunmamış bildirim sayısını getir
  getUnreadCount: async () => {
    return await apiRequest('/notifications/notifications/unread_count/');
  },

  // Bildirimi okundu olarak işaretle
  markAsRead: async (notificationId) => {
    return await apiRequest(`/notifications/notifications/${notificationId}/mark_read/`, {
      method: 'POST',
    });
  },

  // Tüm bildirimleri okundu olarak işaretle
  markAllAsRead: async () => {
    return await apiRequest('/notifications/notifications/mark_all_read/', {
      method: 'POST',
    });
  },

  // Bildirimi arşivle
  archiveNotification: async (notificationId) => {
    return await apiRequest(`/notifications/notifications/${notificationId}/archive/`, {
      method: 'POST',
    });
  },

  // Bildirimi güncelle
  updateNotification: async (notificationId, data) => {
    return await apiRequest(`/notifications/notifications/${notificationId}/`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },
};

export default notificationsApiService;
